var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sub-action-selector-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        staticClass: "header",
        attrs: { headerTitle: _vm.texts.title },
      }),
      [
        _c("span", { staticClass: "required-fields-advice-base" }, [
          _vm._v(_vm._s(_vm.texts.infoAdvice)),
        ]),
        _c("LexonSelectComponent", {
          staticClass: "lexon-select",
          attrs: {
            id: "actionId",
            name: "actionId",
            label: _vm.texts.label,
            keyName: "subject",
            keyValue: "id",
            serverPagination: true,
            attach: false,
            validationRules: "required",
            returnObject: false,
            tableHeaders: _vm.tableHeaders,
            endPointEntity: _vm.receiverEndPointEntity,
          },
          model: {
            value: _vm.selectedActionId,
            callback: function ($$v) {
              _vm.selectedActionId = $$v
            },
            expression: "selectedActionId",
          },
        }),
      ],
      _c("CustomDialogActionButtonsComponent", {
        staticClass: "actions",
        attrs: {
          primaryButtonText: _vm.texts.save,
          mainAction: _vm.save,
          disabledButtons: !_vm.selectedActionId,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }